"use strict";
/*
 * Centralized reporter for bot traffic. Pushes the `traffic_check` dataLayer
 * event consumed by GTM/GA. Behavior hooks call this when they detect a bot.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAgentBotEvent = exports.trackBotTraffic = void 0;
const trackBotTraffic = (action) => {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'behavior_telemetry',
        telemetry_metric: action,
    });
    // window.dataLayer = window.dataLayer || []
    // window.dataLayer.push({
    //   event: 'traffic_check',
    //   traffic_type: 'bot',
    // })
};
exports.trackBotTraffic = trackBotTraffic;
const userAgentBotEvent = () => {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'traffic_check',
        traffic_type: 'bot',
    });
};
exports.userAgentBotEvent = userAgentBotEvent;
